import { useCallback, useEffect, useState } from 'react';

import { PlusCircleOutlined } from '@ant-design/icons';
import { Table, notification, Button, Divider, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';

import cuisinesService from '../../../../services/cookbook/cuisines-service';
import CuisineType from '../../../../typings/cookbook/CuisineType';
import TitledCard from '../../../layout-components/titled-card';
import Flex from '../../../layouts/flex';

const CuisinesList: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [cuisines, setCuisines] = useState<Array<CuisineType>>([]);

  const reloadList = () => {
    cuisinesService.getCuisines().then((response) => {
      setCuisines(response.cuisines);
      setLoading(false);
    });
  };

  useEffect(reloadList, []);

  const removeItem = useCallback((record: CuisineType) => {
    setLoading(true);
    cuisinesService
      .deleteCuisine(record.id)
      .then(() => {
        notification.success({
          message: 'Usunięto kuchnię',
          description: (
            <>
              Kuchnia <strong>{record.name_pl}</strong> została usunięta.
            </>
          ),
        });
        reloadList();
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const columns = [
    {
      title: 'Nazwa',
      dataIndex: 'name_pl',
      render: (name_pl: string, record: CuisineType) => (
        <Link to={`${record.id}/edit`}>{name_pl}</Link>
      ),
    },
    {
      title: 'Nazwa (EN)',
      dataIndex: 'name_en',
    },
    {
      title: 'Operacje',
      key: 'action',
      width: 200,
      align: 'center' as const,
      render: (_text: string, record: CuisineType) => (
        <span>
          <Link to={`${record.id}/edit`}>
            <Button type="primary" size="small">
              Edycja
            </Button>
          </Link>

          <Divider type="vertical" />

          <Popconfirm
            title={
              <>
                Czy na pewno usunąć kuchnię <strong>{record.name_pl}</strong>?
              </>
            }
            onConfirm={() => removeItem(record)}
            okText="Tak"
            cancelText="Nie"
          >
            <Button type="primary" size="small" danger>
              Usuń
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <TitledCard title="Lista kuchnii">
      <Flex className="mb-3" alignItems="center" justifyContent="end" mobileFlex={false}>
        <div>
          <Link to="new">
            <Button type="primary" icon={<PlusCircleOutlined />} block>
              Dodaj kuchnię
            </Button>
          </Link>
        </div>
      </Flex>
      <Table
        rowKey="id"
        dataSource={cuisines}
        columns={columns}
        bordered
        loading={loading}
        pagination={false}
      />
    </TitledCard>
  );
};
export default CuisinesList;
